export const backtotop = {
  name: 'back-to-top',

  bind: (el) => {
    const element = el;
    const windowH = window.innerHeight * 2;

    window.addEventListener('scroll', function () {
      if (window.scrollY > windowH) {
        element.style.opacity = 1;
      } else {
        element.style.opacity = 0;
      }
    });
  }
};
